import { FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import {
  EnhancedFormControl,
  FormArrayEnhanced,
  FormGroupEnhanced,
  IConfig,
  IFormConfig,
} from '../../models/rt-common';

/**
 * 將formControl的陣列欄位轉換至FormArrayEnhanced
 * @param useFormArr
 * @param useControlArr
 * @param useConfig
 */
const convertToFormArray = (
  useFormArr: FormArrayEnhanced | FormArray,
  useControlArr: any[] | undefined,
  useConfig?: IConfig<any>
) => {
  const useRawControllArr = useControlArr;
  if (useRawControllArr) {
    //  該array非空陣列，外繼續往下
    useFormArr.controls = [];
    if (useRawControllArr?.[0]) {
      const objKeys = Object.keys(useControlArr?.[0]);
      useRawControllArr.forEach(
        async (useArrElement: { [x: string]: string }) => {
          const useControls = {} as any;
          objKeys.forEach((key) => {
            if (
              _.isObjectLike(useArrElement[key]) &&
              !_.isArray(useArrElement[key]) &&
              !_.isDate(useArrElement[key])
            ) {
              const useInnerControls = {} as any;
              const useInnerArrElement = useArrElement[key] as any;
              Object.keys(useInnerArrElement).forEach(async (innerKey) => {
                useInnerControls[innerKey] = new EnhancedFormControl(
                  '',
                  useInnerArrElement[innerKey]
                );
                if (_.isArray(useInnerArrElement[innerKey])) {
                  console.log(
                    'testArrLike',
                    useInnerArrElement[innerKey],
                    innerKey
                  );
                  if (useInnerControls[innerKey].formArray == null) {
                    useInnerControls[innerKey].formArray =
                      new FormArrayEnhanced(
                        [] as FormGroupEnhanced<IFormConfig<any>>[]
                      );
                  }
                  await useInnerControls[innerKey].setFormControlToFormArray();
                }
              });

              useControls[key] = new FormGroupEnhanced(useInnerControls);
            } else {
              useControls[key] = new EnhancedFormControl(
                '',
                useArrElement[key]
              );
              if (_.isArray(useArrElement[key])) {
                if (useControls[key].formArray == null) {
                useControls[key].formArray = new FormArrayEnhanced(
                  [] as FormGroupEnhanced<IFormConfig<any>>[]
                )
              }
                useControls[key].setFormControlToFormArray();
              }
            }
          });
          const useFormGroup = new FormGroupEnhanced(useControls);
          //如有傳入config,會將formConfig對於useFormArr進行必填及格式檢查設定
          if (useConfig) {
            await useFormGroup.genFormByConfig(useConfig);
          }
          useFormArr.push(useFormGroup);
        }
      );
    }
  }
};
/**
 * 將FormArrayEnhanced的值塞入formControl裡的陣列
 * @param useControlArr
 * @param useFormArr
 */
const setValueToFormControlArr = (
  useControlArr:
    | FormGroupEnhanced<IFormConfig<any[] | undefined>>
    | EnhancedFormControl
    | FormControl
    | undefined,
  useFormArr: FormArrayEnhanced | FormArray
) => {
  const useRaeValue = useFormArr.getRawValue();
  if (useRaeValue && useControlArr) {
    useControlArr.setValue(useRaeValue);
  }
};

export { convertToFormArray, setValueToFormControlArr };
